// extracted by mini-css-extract-plugin
module.exports = {"selectionContainer":"step-2-draw-cards-module__selectionContainer___2R3az"};